import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import moment from 'moment';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsServiceJsonAuthorization from '../../services/axios/tmsServiceJsonAuthorization';
import JsonExcel from 'vue-json-excel';
import qs from 'qs';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import GoogleMaps from '../../components/googleMaps';
import pager from '../../components/pager';
import template from './home.vue';
import DefaultModal from '../../components/modal';
import { join, forEach, pick, map, groupBy } from 'lodash-es';
import UnisProductModal from '../../components/unisProductModal';
import DeliveryStatus from '../../components/deliveryStatus';
import ScheduledDeliveryDate from '../../components/scheduled-delivery-date';
import PayBalance from '../../components/payBalance';
import WaitingButton from '../../components/waiting-button/waiting-button.vue';
import OrderStatusColors from '../../components/orderStatusColors';
import OrderStatusBgColor from '../../components/orderStatusBgColor';
import OrderStatusShow from '../../components/orderStatusShow';
import util from '../../shared/util';
import switchBillingToService from '../../shared/switchBillingToService';

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);

@Component({
    mixins: [template],
    components: {
        downloadExcel: JsonExcel,
        DefaultModal,
        pager,
        GoogleMaps,
        UinsDefaultSelect,
        UnisProductModal,
        DeliveryStatus,
        ScheduledDeliveryDate,
        PayBalance,
        OrderStatusColors,
        OrderStatusBgColor,
        OrderStatusShow,
        WaitingButton,
    },
})
export default class Home extends Vue {
    orderId: string = '';
    tasksList: Array<any> = [];
    shipmentsList: Array<any> = [];
    quotesList: Array<any> = [];
    shipmentsSearchInfo: any = {};
    quotesSearchInfo: any = {};
    deleteTaskId: any = '';
    userName: any = '';
    deliveryStatusShipment: any = {};
    MapStatusShipment: any = {};
    showTask: Boolean = false;
    statusArr: any = [
        { value: '0', label: 'All' },
        { value: '1', label: 'Accepted' },
        { value: '2', label: 'Expired' },
        { value: '3', label: 'Needs review' },
    ];
    orderStatuses: Array<any> = [
        { label: 'All', value: '0' },
        { label: 'Pickup Created', value: '1' },
        { label: 'Pickup Dispatched', value: '2' },
        { label: 'Pickup Completed', value: '3' },
        { label: 'In Transit', value: '4' },
        { label: 'Pending Delivery', value: '5-1' },
        { label: 'Out for Delivery', value: '5' },
        { label: 'Delivered', value: '6' },
    ];
    setmarkers: Array<any> = [];
    setCenter: any = {
        lat: 0,
        lng: 0,
    };
    bill_to_id: any = '';
    quotPaging: any = {
        page_size: 4,
        page: 1,
        totalSize: 0,
    };
    shipmentsPaging: any = {
        page_size: 10,
        page: 1,
        totalSize: 0,
    };

    tasksPaging: any = {
        page_size: 10,
        page: 1,
        totalSize: 0,
    };
    errorText: String = '';
    showErrTip: Boolean = false;
    trackedShipment: any = {};
    mapDeliveryStatusShipment: any = {};
    deliveryStages: any = 0;
    historys: any = [];
    selectShipmentOrderPro: any = '';
    searchEmpty: Boolean = false;

    isShowTasksPaging: boolean = false;
    isBindingMeijerBillto: boolean = false;
    triniumTripList: Array<any> = [];
    opMakeIndex: any = -1;
    isShowShipmentsPaging: boolean = false;
    makeLoading: any = -1;
    choosingUNIS: string = 'choosingUNIS';
    deleteProductModal: string = 'deleteProductModal';
    isBusinessType: boolean = false;
    isGuideDone: boolean = false;
    isMaxTotalMiles: boolean = false;
    businesstype: any = '';
    businessTypes: Array<any> = [
        { key: 1, code: null, title: 'Residential/End user' },
        { key: 2, code: 'CON', title: 'Sole Proprietor/Small business' },
        { key: 3, code: 'SHOW', title: 'Medium - Large business' },
        { key: 4, code: null, title: 'Fortune 500/Global organization' },
        { key: 5, code: 'RES', title: 'Government/NGO' },
        { key: 6, code: null, title: 'Trucking/Warehousiing' },
    ];
    currentShiment: any = {};
    selectShiment: any = {};

    isSearchingShipment = false;
    isGettingActiveShipments = false;

    async mounted() {
        this.userName = localStorage.getItem('UserFirstLast');
        this.isBusinessType = localStorage.getItem('businessType') == 'true' ? true : false;
        if (!this.isBusinessType) {
            this.$modal.show(this.choosingUNIS);
        } else {
            util.showUserWalkthrough();
        }
        this.bill_to_id = await this.getCustomerInfo();
        if (this.bill_to_id) {
            this.getTasksList(1);
            // this.getQuoteList(1);
            this.getShipmentsList(1);
            this.getInvoicesList(1);
            // this.getAllShipmentsList();
        }
    }

    getCustomerInfo() {
        return new Promise((resolve: any, reject: any) => {
            switchBillingToService.post().then(
                (res: any) => {
                    if (
                        res &&
                        res.data &&
                        res.data.billing != undefined &&
                        res.data.billing.is_binding_meijer_billto &&
                        res.data.billing.is_binding_meijer_billto == 'Y'
                    )
                        this.isBindingMeijerBillto = true;
                    if (
                        res &&
                        res.data &&
                        res.data.billing != undefined &&
                        res.data.billing.location_id
                    ) {
                        localStorage.setItem('BillToId', res.data.billing.location_id);
                        resolve(res.data.billing.location_id);
                    } else {
                        reject('');
                    }
                },
                (err: any) => {
                    // //console.log(err);
                    reject(err);
                }
            );
        });
    }

    goToRequestQuote() {
        this.$router.replace({
            name: 'Quote',
        });
    }

    onGetQuoteList(page: any) {
        this.getQuoteList(page.currentPage);
    }

    onGetShipmentsList(page: any) {
        this.shipmentsPaging.page_size = page.pageSize;
        this.getShipmentsList(page.currentPage);
    }

    changeQuotesStatus() {
        this.getQuoteList(1);
    }

    onGetTasksList(page: any) {
        this.tasksPaging.page_size = page.pageSize;
        this.getTasksList(page.currentPage);
    }

    changeShipmentsStatus() {
        this.getShipmentsList(1);
    }

    getTasksList(page: any) {
        let url = `cpv2/task/getTasks?billto_id=${this.bill_to_id}&page_size=${
            this.tasksPaging.page_size
        }&page=${page}`;
        tmsServiceBackend.get(url).then(
            (response: any) => {
                this.tasksList = response.data.data.data;
                this.tasksPaging.totalSize = response.data.data.total;
                this.tasksPaging.page = response.data.data.current_page;
            },
            (err: any) => {
                this.err(err.response.data.message);
            }
        );
    }

    getQuoteList(page: any) {
        let url = `/quote/getQuoteLines?billto_id=${
            this.bill_to_id
        }&quote_from=LAST_MILE_SERVICE,TMS_MILE_SERVICE,TMS_QUOTE_SERVICE,UNIS_500_QUOTE_SERVICE&page_size=${
            this.quotPaging.page_size
        }&page=${page}`;
        if (this.quotesSearchInfo.status && this.quotesSearchInfo.status != '0')
            url = url + `&input_search_status_type=${this.quotesSearchInfo.status}`;
        tmsServiceBackend.get(url).then(
            (res: any) => {
                this.quotesList = res.data.data;
                this.quotesList.forEach((item: any) => {
                    item.showOption = false;
                    item.isSelect = false;
                });
                this.quotPaging.pageSize = res.data.per_page;
                this.quotPaging.page = res.current_page;
                this.quotPaging.totalSize = res.data.total;
            },
            (err: any) => {
                this.err(err.response.data.message);
            }
        );
    }

    getShipmentsList(page: any) {
        if (this.isBindingMeijerBillto) {
            let params: any = {};
            params.billto_id = this.bill_to_id;
            params.page = page;
            params.page_size = this.shipmentsPaging.page_size;
            tmsServiceJsonAuthorization.post('/trinium/trip/list', params).then(
                (response: any) => {
                    this.makeLoading = -1;
                    this.opMakeIndex = -1;
                    this.triniumTripList = response.data.data.data;
                    this.shipmentsPaging.totalSize = response.data.data.total;
                    this.shipmentsPaging.page = response.data.data.current_page;
                    this.fillMakeOrderHOT(this.triniumTripList);
                },
                (err: any) => {
                    this.err(err.response.data.message);
                }
            );
            return;
        }
        let params: any = {};
        params.billto_id = this.bill_to_id;
        params.page = page;
        params.quote_from = 'LAST_MILE_SERVICE,TMS_MILE_SERVICE';
        if (this.shipmentsSearchInfo.status && this.shipmentsSearchInfo.status != '0') {
            if (this.shipmentsSearchInfo.status == '5-1') {
                params.status_type = '5';
                params.is_trip_order_created_from_lh = '1';
            } else {
                if (this.shipmentsSearchInfo.status == '5') {
                    params.is_trip_order_created_from_lh = '0';
                }
                params.status_type = this.shipmentsSearchInfo.status;
            }
        }
        params.page_size = this.shipmentsPaging.page_size;
        this.isGettingActiveShipments = true;
        tmsServiceBackend.post('/order/getOrderList', qs.stringify(params)).then(
            (response: any) => {
                if (response.data && response.data.data && response.data.data.data) {
                    this.shipmentsList = response.data.data.data;
                    this.shipmentsPaging.totalSize = response.data.data.total;
                    this.shipmentsPaging.page = response.data.data.current_page;
                    if (this.shipmentsList && this.shipmentsList[0])
                        this.setGoogleMap(this.shipmentsList[0]);
                }
                this.isGettingActiveShipments = false;
            },
            (err: any) => {
                this.isGettingActiveShipments = false;
                this.err(err.response.data.message);
            }
        );
    }

    getAllShipmentsList() {
        this.setmarkers = [];
        let params: any = {};
        params.billto_id = this.bill_to_id;
        params.page = 1;
        params.quote_from = 'LAST_MILE_SERVICE,TMS_MILE_SERVICE';
        params.page_size = '100000';
        params.from_page = 'dashboard';
        tmsServiceBackend.post('/order/getOrderList', qs.stringify(params)).then(
            (response: any) => {
                let markers = map(response.data.data.data, item => {
                    return pick(item, ['delivery_lat', 'delivery_lng', 'pickup_lat', 'pickup_lng']);
                });
                forEach(markers, mark => {
                    this.setmarkers.push([
                        {
                            lat: Number(mark['pickup_lat']),
                            lng: Number(mark['pickup_lng']),
                            total_Miles: mark['total_Miles'],
                            locationState: mark['pickup_location_state'],
                            city: mark['pickup_location_city'],
                            state: 'continuous',
                        },
                        {
                            lat: Number(mark['delivery_lat']),
                            lng: Number(mark['delivery_lng']),
                            total_Miles: mark['total_Miles'],
                            locationState: mark['delivery_location_state'],
                            city: mark['delivery_location_city'],
                            state: 'finish',
                        },
                    ]);
                });
                this.setmarkers = this.setmarkers.slice(1, 2);
                this.setCenter = this.setmarkers[0][0];
            },
            (err: any) => {
                this.err(err.response.data.message);
            }
        );
    }

    generateBOL(orderId: any) {
        this.$router.push({
            name: 'Billoflading',
            params: {
                orderId: orderId,
            },
        });
    }

    setGoogleMap(item: any) {
        console.log(item);
        this.setmarkers = [];
        this.setmarkers.push(
            {
                lat: Number(item['pickup_lat']),
                lng: Number(item['pickup_lng']),
                total_Miles: item['total_Miles'],
                locationState: item['pickup_location_state'],
                city: item['pickup_location_city'],
                state: 'continuous',
            },
            {
                lat: Number(item['delivery_lat']),
                lng: Number(item['delivery_lng']),
                total_Miles: item['total_Miles'],
                locationState: item['delivery_location_state'],
                city: item['delivery_location_city'],
                state: 'finish',
            }
        );

        this.setCenter = {
            lat: Number(item['pickup_lat']),
            lng: Number(item['pickup_lng']),
        };
    }

    SaveBusinesstype(item: any) {
        tmsServiceBackend
            .post(
                '/cpv2/settings/companyAccount/setBusinessType',
                qs.stringify({ business_type: this.businesstype })
            )
            .then(
                (response: any) => {
                    if (response.data.status == 1) {
                        this.succeed('Save business type succeed !');
                    }
                    if (response.data.status == 0) {
                        this.err(response.data.message);
                    }
                    this.$modal.hide(this.choosingUNIS);
                    util.showUserWalkthrough();
                    localStorage.setItem('businessType', 'true');
                },
                (err: any) => {
                    this.err(err.response.data.message);
                    util.showUserWalkthrough();
                    this.$modal.hide(this.choosingUNIS);
                }
            );
    }

    fiterTime(dateTime: any) {
        if (dateTime) {
            let time = moment(dateTime).format('LLLL');
            return join(time.split(',').slice(0, 2), ',');
        }
    }

    async showMapRoute(shipment: any) {
        this.currentShiment = {};
        this.MapStatusShipment = shipment;
        this.currentShiment = shipment;
        this.choosingUNIS = 'googleMap';
        this.mapDeliveryStatusShipment = {};
        this.fillTrackedShipment(this.currentShiment);
        this.$modal.show(this.choosingUNIS);
        this.setGoogleMap(shipment);
        await this.searchTrackShipment(shipment.order_pro, shipment.order_id).then(
            (res: any) => {
                if (res.data.message != 'success') {
                    this.err(`${res.data.message}`);
                    return;
                }
                if (res.data.message == 'No matching order found.') {
                    this.searchEmpty = true;
                }
                this.mapDeliveryStatusShipment = res.data.data[0] || {};
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    private searchTrackShipment(text: any, orderId: any) {
        return new Promise((resolve, reject) => {
            tmsServiceBackend
                .get(
                    `/cpv2/tracking/trackShipment?search_text=${text || orderId}&billto_id=${
                        this.bill_to_id}&request_from=V2`
                )
                .then(
                    (res: any) => {
                        resolve(res);
                    },
                    (err: any) => {
                        this.showErrorFun(err.response.data.message);
                    }
                );
        });
    }

    async getTrackShipment(shipment: any, text: string) {
        this.selectShipmentOrderPro = text;
        this.currentShiment = shipment;
        this.trackedShipment = {};
        this.deliveryStatusShipment = {};
        this.searchEmpty = false;
        this.isSearchingShipment = true;
        await this.searchTrackShipment(text, shipment.order_id).then(
            (res: any) => {
                this.isSearchingShipment = false;

                if (res.data.message != 'success') {
                    this.err(`${res.data.message}`);
                    return;
                }
                if (res.data.message == 'No matching order found.') {
                    this.searchEmpty = true;
                }
                this.trackedShipment = res.data.data[0] || {};
                this.currentShiment = res.data.data[0] || {};
                this.filterData(this.currentShiment, res.data.data[0]);
                this.filterData(this.trackedShipment, res.data.data[0]);
                this.deliveryStatusShipment = res.data.data[0] || {};
                this.fillTrackedShipment(this.trackedShipment);
                // this.fillTrackedShipment(this.deliveryStatusShipment);
                this.fillTrackedShipment(this.currentShiment);
                this.currentShiment.order_pro = text;
            },
            (err: any) => {
                console.log(err);
                this.isSearchingShipment = false;
            }
        );
    }

    private filterData(data: any, filterData: any) {
        data.delivery_lat = filterData.delivery_lat;
        data.delivery_lng = filterData.delivery_lng;
        data.delivery_location_city = filterData.delivery_city;
        data.delivery_location_name = filterData.delivery_name;
        data.delivery_location_state = filterData.delivery_state;
        data.order_id = filterData.order_id;
        data.order_pro = filterData.pro;
        data.order_stage = filterData.stage;
        data.pickup_lat = filterData.pickup_lat;
        data.pickup_lng = filterData.pickup_lng;
        data.pickup_location_city = filterData.pickup_city;
        data.pickup_location_name = filterData.pickup_name;
        data.pickup_location_state = filterData.pickup_state;
        data.pu_id = filterData.pu;
    }

    private fillTrackedShipment(trackedShipment: any) {
        /* trackedShipment.d_time_from = (trackedShipment.d_time_from && trackedShipment.d_time_from != '0') ? moment(new Date('2022/01/01 ' + trackedShipment.d_time_from)).format('HH:mm a') : '';
         trackedShipment.d_time_to = (trackedShipment.d_time_to  && trackedShipment.d_time_to != '0' ) ? moment(new Date('2022/01/01 ' + trackedShipment.d_time_to)).format('HH:mm a') : '';*/
        forEach(trackedShipment.histories, history => {
            let time = moment(history.tms_order_log_created_date).format('LLLL');
            let year = moment(history.tms_order_log_created_date).format('YYYY');
            let timeArray = time.split(',');
            history['groupName'] = join(timeArray.slice(0, 2), ',') + ',' + year;
            let cDateYear = moment(history.c_date).format('MM/DD/YYYY');
            let cDateTime = moment(history.c_date).format('HH:mm A');
            history['cDateYear'] = cDateYear;
            history['cDateTime'] = cDateTime;
        });
        this.historys = groupBy(trackedShipment.histories, 'groupName');
        this.getProgressImage(trackedShipment.stage, trackedShipment.status);
    }

    private getProgressImage(shipmentStage: any, shipmentStatus: any) {
        if (shipmentStatus == 4 && shipmentStage == 5) {
            // Invoiced
            this.deliveryStages = 4;
        } else if (shipmentStage == 5 && shipmentStatus > 0) {
            // Delivered
            this.deliveryStages = 4;
        } else if (shipmentStage == 4 && shipmentStatus > 0) {
            // Out for Delivery
            this.deliveryStages = 3;
        } else if (shipmentStage == 1 || shipmentStage == 2 || shipmentStage == 3) {
            // Picked U
            this.deliveryStages = 2;
        } else if (shipmentStage == 0 && shipmentStatus > 1) {
            // In Process
            this.deliveryStages = 1;
        } else if (shipmentStage == 0 && shipmentStatus == 1) {
            // In Process (Order created)
            this.deliveryStages = 1;
        }
        this.$forceUpdate();
    }

    reference(orderId: any) {
        this.$router.push({
            name: 'ShipmentView',
            params: {
                orderId: orderId,
                from: '5',
            },
        });
    }

    showOrHideTask() {
        this.showTask = !this.showTask;
    }

    showSelectShipment(shipment: any) {
        this.selectShiment = shipment;
    }

    closeModal() {
        this.$modal.hide(this.choosingUNIS);
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    searchParams: any = {
        page_size: 10,
        page: 1,
        search_term: '',
        status_array: [],
        order_by: '',
    };
    invoicesArr: Array<any> = [];
    isShowInvoicesArr: Boolean = false;
    InvoicesPaging: any = {
        page_size: 10,
        page: 1,
        totalSize: 0,
    };
    showInvoicesPages: Boolean = false;

    onGetInvoicesList(page: any) {
        this.searchParams.page_size = page.pageSize;
        this.getInvoicesList(page.currentPage);
    }

    clickShowInvoicesPages() {
        this.isShowInvoicesArr = !this.isShowInvoicesArr;
    }

    getInvoicesList(page: number) {
        this.searchParams.page = page;
        this.searchParams.status_array = ['1', '3'];
        this.searchParams.billto_id = this.bill_to_id;
        tmsServiceBackend.get(`/tms/invoices/list_v2?${qs.stringify(this.searchParams)}`).then(
            (res: any) => {
                this.invoicesArr = res.data.data.details;
                this.InvoicesPaging.currentPage = res.data.data.page.current_page;
                this.InvoicesPaging.totalSize = res.data.data.page.total_num;
                this.InvoicesPaging.past_due_text = res.data.data.past_due_text;
                if (this.InvoicesPaging.past_due_text) {
                    this.errorText = this.InvoicesPaging.past_due_text;
                    this.showErrTip = true;
                }
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    exportPdf(url: string) {
        window.open(url);
    }

    shipmentView(id: any) {
        localStorage.setItem('ShipmentViewFrom', '1');
        this.$router.push({
            name: 'ShipmentView',
            params: {
                orderId: id,
                from: '2',
            },
        });
        /* this.$router.replace({
         name: 'ViewShipment',
         params: {
         id: id
         }
         });*/
    }

    isSelectAll: Boolean = false;
    payInvoice: any = [];
    payOptionVal: any = 1;
    outstandingList: any = [];
    payTitle: string = 'Pay for selected invoices';
    editProductModal: string = 'payBalance';

    makePayment(item: any) {
        this.orderId = item.order_id;
        forEach(this.invoicesArr, item => {
            item.isSelect = false;
        });
        this.isSelectAll = false;
        this.payInvoice = [];
        this.payInvoice.push(item);
        this.payOptionVal = 1;
        this.payTitle = 'Pay for selected invoices';
        this.$modal.show(this.editProductModal);
    }

    closePayInvoiceModal() {
        this.payInvoice = [];
        this.$modal.hide(this.editProductModal);
    }

    chargeSuccess() {
        this.payInvoice = [];
        this.$modal.hide(this.editProductModal);
        this.showUpdated({ title: 'Pay Result', mag: 'Pay successfully' });
        this.getInvoicesList(1);
    }

    clickViewAll() {
        this.$router.push({
            name: 'Invoices',
            params: {
                from: '13',
            },
        });
    }

    closeTips() {
        this.showErrTip = false;
    }

    fillMakeOrderHOT(dataList: any) {
        forEach(dataList, (data: any, index: any) => {
            if (data.mark == 'Y') this.$set(data, 'isMakeOrderHOT', true);
            else this.$set(data, 'isMakeOrderHOT', false);
        });
    }

    onMakeOrderHOT(item: any, opMakeIndex: any) {
        this.makeLoading = opMakeIndex;
        this.opMakeIndex = -1;
        tmsServiceJsonAuthorization.post('/trinium/trip/mark', { trip_id: item.trip_id }).then(
            (response: any) => {
                this.getShipmentsList(1);
            },
            (err: any) => {
                this.err(err.response.data.message);
            }
        );
    }

    onOpMakeIndex(index: any) {
        this.opMakeIndex = index;
    }

    onUnmarkMakeOrderHOT(item: any, opMakeIndex: any) {
        this.opMakeIndex = -1;
        this.makeLoading = opMakeIndex;
        tmsServiceJsonAuthorization.post('/trinium/trip/unmark', { trip_id: item.trip_id }).then(
            (response: any) => {
                this.getShipmentsList(1);
            },
            (err: any) => {
                this.err(err.response.data.message);
            }
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
        next();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/home/index.ts